import React, { FC } from 'react';

import classNames from 'classnames';

import { EvButton, EvIcon } from '@evinced-private/ui-common';

import EmptyCollections from 'src/components/icons/EmptyCollections.svg?raw';
import QuickTipIcon from 'src/components/icons/QuickTipIcon.svg?raw';

import { LoadErrorMsgLayout } from '../../pages/property/LoadErrorMsgLayout';
import { useConfiguration } from '../../providers/configurationProvider/ConfigurationProvider';
import { SiteScannerUiToggles } from '../../services/LocalTogglesService';

import './NoDataInCollection.scss';

interface INoDataInCollection {
	className?: string;
	handleClearFilters?: () => void;
}

const MAIN_TITLE = '"My collection" is empty';
const MAIN_TITLE_MULTIPLE_COLLECTIONS = 'No properties found';
const SECONDARY_MESSAGE =
	'In order to view your key properties filtered from the rest, please add at least one property to “My collection”.';
const SECONDARY_MESSAGE_MULTIPLE_COLLECTIONS = 'Try changing the filters.';
const NO_DATA_IMG_ALT_TEXT =
	'To add a property, click on the actions menu, (located at the end of the property row you wish to add), and select “Add to My collection”';

export const NoDataInCollection: FC<INoDataInCollection> = ({
	className,
	handleClearFilters
}): JSX.Element => {
	const { getToggle } = useConfiguration();

	// TODO: remove this when multiple collections feature is fully integrated
	const isMultipleCollectionsEnabled = getToggle(SiteScannerUiToggles.ENABLE_MULTIPLE_COLLECTIONS);

	return (
		<div className={classNames('no-data-in-collection-wrapper', { [className]: !!className })}>
			{isMultipleCollectionsEnabled ? (
				<LoadErrorMsgLayout
					mainTitle={MAIN_TITLE_MULTIPLE_COLLECTIONS}
					secondaryMsg={SECONDARY_MESSAGE_MULTIPLE_COLLECTIONS}
					icon={EmptyCollections}
				>
					<div className="button-container">
						<EvButton onClick={handleClearFilters} className="clear-filters-button">
							Clear Filters
						</EvButton>
					</div>
				</LoadErrorMsgLayout>
			) : (
				<LoadErrorMsgLayout
					mainTitle={MAIN_TITLE}
					secondaryMsg={SECONDARY_MESSAGE}
					icon={EmptyCollections}
				>
					<EvIcon icon={QuickTipIcon} title={NO_DATA_IMG_ALT_TEXT} className="quick-tip" />
				</LoadErrorMsgLayout>
			)}
		</div>
	);
};
